import React from 'react'
import styled from 'styled-components'

const StyledLabel = styled.div`
  font-size: 14px;
  color: #5d5c70;
  margin-bottom: 5px;
`

export const Label = ({ children, ...props }) => {
  return <StyledLabel {...props}>{children}</StyledLabel>
}
